import NetworkingOperations from "../index";

const PassesActivate = (data) => {
	const url = process.env.REACT_APP_PASSES_ACTIVATE;

	return NetworkingOperations.post({ url, data }).then((res) => res);
};

export default PassesActivate;
